export default __webpack_public_path__ + "static/media/Road Use Pricing.20bda21c.pdf";